import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { site } from "../data/siteConfig";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-black" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-16">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-script text-4xl text-hotpink md:text-5xl">
            Yaya Just Did That
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/55">
            {site.promise}
          </p>
          <div className="mt-5 flex items-center gap-2 text-sm text-white/60">
            <MapPin className="h-4 w-4 text-hotpink" />
            {site.location}
          </div>
        </div>

        <nav aria-label="Footer" className="grid grid-cols-2 gap-3 text-sm">
          {site.nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="text-white/60 transition-colors duration-300 hover:text-hotpink"
            >
              {n.label}
            </Link>
          ))}
          <Link to="/book" className="font-semibold text-hotpink">
            Book
          </Link>
        </nav>

        <div className="flex flex-col items-start gap-4">
          <a
            href={site.instagram.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-white/70 transition-colors duration-300 hover:text-hotpink"
            data-testid="footer-instagram-link"
          >
            <Instagram className="h-4 w-4 text-hotpink" />
            {site.instagram.handle}
          </a>
          <span className="flex items-center gap-2 text-sm text-white/40">
            <Mail className="h-4 w-4 text-hotpink/60" />
            {site.email} <em className="text-xs not-italic">(placeholder)</em>
          </span>
          <img
            src={site.assets.qr}
            alt="Instagram QR code for @hairbyyaya_didthat"
            className="w-24 rounded-xl border border-white/15"
            loading="lazy"
          />
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
        <p>© {site.year} HairByYaya. All Rights Reserved.</p>
        <div className="flex gap-6">
          <span className="cursor-pointer transition-colors duration-300 hover:text-white/70">
            Privacy
          </span>
          <span className="cursor-pointer transition-colors duration-300 hover:text-white/70">
            Terms
          </span>
        </div>
      </div>
    </div>
  </footer>
);

